module.exports = __webpack_public_path__ + "img/roll_l copy.be5e3f78.png";